import { useQuery } from '@tanstack/react-query';

import type { AuthenticatedUser } from '@dcc-erp/shared';

import { api } from '../api';

// Effective user (incl. roles/permissions) for the active company.
export function useMe(companyId: string | undefined) {
  return useQuery({
    queryKey: ['me', companyId],
    queryFn: () => api<AuthenticatedUser>(`/auth/me${companyId ? `?companyId=${companyId}` : ''}`),
    enabled: !!companyId,
    staleTime: 60_000,
  });
}
